import { LoggerTechHandler } from '@direct-frontend/modules-logger';
import { useEffect } from 'react';

interface LogErrorsParameters {
    logTech: LoggerTechHandler;
    errors?: string[];
}

export const useLogErrors = (id: string, { errors, logTech }: LogErrorsParameters) => {
    const errorsString = errors?.join('|');

    useEffect(() => {
        if (errorsString) {
            logTech('clientError', {
                id,
                errors: errorsString.split('|').map(errorText => ({ code: 'filter_error', text: errorText })),
            });
        }
    }, [logTech, errorsString, id]);
};
